import { render, staticRenderFns } from "./DirectionsTextWithImageBlock.vue?vue&type=template&id=61ac2b4b&"
import script from "./DirectionsTextWithImageBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsTextWithImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsTextWithImageBlock.vue?vue&type=style&index=0&id=61ac2b4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports